import styled from 'styled-components';
import { ReactComponent as IntegrationsGraphic } from '@elementary/common-ui/assets/integrations-graphic.svg';
import { ReactComponent as SleepyCloud } from '@elementary/common-ui/assets/sleepy-cloud.svg';
import { Button, FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useAccountPermission from '@elementary/common-ui/hooks/useAccountPermission';
import { DWH_CREATE } from '@elementary/common-ui/constants/urlParams';
import { fontSize, space } from '@elementary/common-ui/style/utils';

const Wrapper = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: ${space('xxl')};
  padding-bottom: ${space('huge')};
`;

const Title = styled(Typography)`
  font-size: ${fontSize('xxl')};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  text-align: center;
`;

const Message = styled(Typography)`
  font-size: ${fontSize('lg')};
  color: ${({ theme }) => theme.palette.content.secondary};
  width: 480px;
  text-align: center;
`;

const NoEnvPage = () => {
  const navigate = useNavigate();
  const hasPermission = useAccountPermission();

  const handleClick = () => {
    navigate(`/settings/environments?${DWH_CREATE}=true`);
  };

  const hasEnvWritePermission = hasPermission('CREATE_ENVIRONMENTS');

  if (!hasEnvWritePermission) {
    return (
      <Wrapper>
        <SleepyCloud />
        <Title>No environments available</Title>
        <Message>
          {`You don't have access to any environments yet.`}
          <br />
          Please contact your administrator to get access.
        </Message>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <IntegrationsGraphic />
      <Title>
        Connect your data warehouse to create your first environment and start
        monitoring your data
      </Title>
      <Button onClick={handleClick}>Create environment</Button>
    </Wrapper>
  );
};

export default NoEnvPage;
